import { getDeptList } from '@/api/settings/employee'
import { generateMapOfIdsArray } from '@/utils/index'
import CONST from '@/utils/const'
import * as Utils from '@/utils/index'

const state = {
  deptData: [], // 部门的cascade格式数据集
  deptMapOfIdsArray: [] // 可按部门ID检索对应的idsArray（部门ID的cascade数组数据格式）
}

const mutations = {
  init: (state, { deptData, deptMapOfIdsArray }) => {
    state.deptData = deptData
    state.deptMapOfIdsArray = deptMapOfIdsArray
  }
}

const actions = {
  // 初始化部门信息
  init({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      getDeptList({
        page: CONST.PAGINATION.PAGE,
        rows: CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc'
      }).then(resp => {
        const deptData = resp.rows || []
        const deptMapOfIdsArray = []
        generateMapOfIdsArray(deptData, deptMapOfIdsArray)
        commit('init', { deptData: deptData, deptMapOfIdsArray: deptMapOfIdsArray })
        dispatch('tip/add', { key: Utils.createUniqueString(), name: '初始化部门信息成功.' }, { root: true })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dept.js